import styled from 'styled-components';

const EndDatesGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export default EndDatesGroup;
